import styled from "styled-components";

export const Input = styled.input`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: 8px;
  border: solid 1px;
  border-color: ${(props) => props.error ? '#ff00008a' : '#00000030'};;
  color: #000000;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  padding-left: 10px;
  &:focus {
    outline: none;
    border: 1px solid #0c1ad0;
  }
`;
